const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    location: {
      type: 'object',
      title: 'location',
      properties: {
        lat: {
          type: 'string',
        },
        lng: {
          type: 'string',
        },
      },
    },
    title: {
      type: 'string',
      title: 'عنوان',
    },
    alias: {
      type: 'string',
      title: 'عنوان لاتین',
    },
    address: {
      type: 'string',
      title: 'آدرس',
    },
    is_active: {
      type: 'number',
      title: 'فعالیت',
      oneOf: [
        { const: 1, title: 'فعال' },
        { const: 0, title: 'غیرفعال' },
      ],
    },
  },
});

export default schema;
